<template>
  <div class="px-8 py-8 w-full" :class="exportruning ? 'cursor-wait' : 'cursor-auto'">
    <div class="text-2xl font-bold">Givare och nyhetsbrevsprenumeranter</div>
    <div class="flex flex-row gap-x-6 items-end justify-end mt-4">
      <div class="text-left">
        <div class="block text-gray-700 text-smaller font-bold" for="event">Roller</div>
        <div class="relative text-base leading-tight w-full cursor-pointer">
          <div class="absolute inline right-0 bottom-0 translate-50-50 w-5 h-5 pointer-events-none">
            <svg class="fill-current" xmlns="http://www.w3.org/2000/svg"
              style="-ms-transform:rotate(90deg);-webkit-transform:rotate(90deg)" viewBox="0 0 24 24"
              transform="rotate(90)">
              <path d="M10.707 17.707L16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" />
              <path fill="rgba(0, 0, 0, 0)" d="M0 0h24v24H0z" />
            </svg>
          </div>
          <div class="border rounded py-2 pl-4 w-40 h-10" @click="roleSelectOpen = !roleSelectOpen">{{ rolesSelected()
            }}</div>
          <div class="absolute rounded-b border border-t-0 py-2 pl-4 bg-white w-40" v-if="roleSelectOpen">
            <div>
              <input type="checkbox" id="skogsfadderRole" v-model="skogsfadderRole">
              <label for="skogsfadderRole">Skogsfadder</label>
            </div>
            <div>
              <input type="checkbox" id="nyhetsbrevRole" v-model="nyhetsbrevRole">
              <label for="nyhetsbrevRole">Nyhetsbrev</label>
            </div>
            <div>
              <input type="checkbox" id="skogsbutikenRole" v-model="skogsbutikenRole">
              <label for="skogsbutikenRole">Skogsbutiken</label>
            </div>
          </div>
        </div>
      </div>
      <div class="text-left">
        <label class="block text-gray-700 text-smaller font-bold" for="name">Namn</label>
        <input v-model="name" class="text-input">
      </div>
      <div class="text-left">
        <label class="block text-gray-700 text-smaller font-bold" for="email">Epost</label>
        <input class="text-input" v-model="email">
      </div>
      <div class="text-left">
        <label class="block text-gray-700 text-smaller font-bold" for="phone">Telefonnummer</label>
        <input class="w-40 text-input" v-model="phone">
      </div>
      <div class="text-left">
        <label class="block text-gray-700 text-smaller font-bold" for="ssn">Personnummer</label>
        <input class="w-40 text-input" v-model="ssn">
      </div>
    </div>
    <div class="flex flex-row gap-x-6 items-end justify-end mt-4">
      <div class="relative text-left" :class="{ 'mr-1': !fromDate }">
        <label class="block text-gray-700 text-smaller font-bold" for="fromDate">Från och med</label>
        <datepicker input-class="datePickerDonors" :clear-button="true" :calendar-button="true"
          calendar-button-icon="fa fa-calendar" :language="sv" v-model="fromDate" format="yyyy-MM-dd"
          :monday-first="true"></datepicker>
      </div>
      <div class="relative text-left" :class="{ 'mr-5': !toDate }">
        <label class="block text-gray-700 text-smaller font-bold" for="toDate">Till och med</label>
        <datepicker input-class="datePickerDonors" :clear-button="true" :calendar-button="true"
          calendar-button-icon="fa fa-calendar" :language="sv" v-model="toDate" format="yyyy-MM-dd"
          :monday-first="true"></datepicker>
      </div>
      <button type="button" @click="fetchDonors" :class="exportruning ? 'cursor-wait' : 'cursor-auto'"
        class="btn shadow-sm tracking-wider px-10 py-2 text-base mt-0 bg-indigo-300">Sök</button>
      <div class="relative text-left left-0">
        <label class="block text-gray-700 text-smaller font-bold" for="export">Exportera resultatet</label>
        <button type="button" @click="exportResult" :disabled="isDisabled"
          :class="exportruning ? 'cursor-wait' : 'cursor-auto'"
          class="btn shadow-sm tracking-wider px-10 py-2 text-base mt-0 bg-indigo-300">Exportera</button>
      </div>
    </div>
    <pagination-controls @next="nextPage" @prev="prevPage" :url="url" :total="total" :perPage="perPage"
      :page="page"></pagination-controls>
    <div class="shadow overflow-hidden rounded border-b border-gray-200">
      <table class="min-w-full bg-white">
        <thead class="bg-gray-800 text-white">
          <tr>
            <th class="text-left py-3 px-4 uppercase font-semibold text-sm">Id</th>
            <th class="text-left py-3 px-4 uppercase font-semibold text-sm">Namn</th>
            <th class="text-left py-3 px-4 uppercase font-semibold text-sm">Epost</th>
            <th class="text-left py-3 px-4 uppercase font-semibold text-sm">Registrerad</th>
            <th class="text-left py-3 px-4 uppercase font-semibold text-sm">Totalt (ca)</th>
            <th class="text-left py-3 px-4 uppercase font-semibold text-sm">Senaste händelse</th>
            <th class="text-left py-3 px-4 uppercase font-semibold text-sm">Telefon</th>
            <th class="text-left py-3 px-4 uppercase font-semibold text-sm">Adress</th>
          </tr>
        </thead>
        <tbody class="text-gray-700">
          <tr v-for="donor in donors" :key="donor.id" @click="show_donor(donor.id)"
            class="hover:bg-teal-100 even:bg-gray-100 cursor-pointer">
            <td class="text-left py-3 px-4">{{ donor.id }}</td>
            <td class="text-left py-3 px-4">{{ donor.name }}</td>
            <td class="text-left p-6 w-4" :title="donor.email" v-html="mail"></td>
            <td class="text-left py-3 px-4">{{ donor.user_registered }}</td>
            <td class="text-left py-3 px-4">{{ donor.total_donated || 0 }} kr</td>
            <td class="text-left py-3 px-4">{{ donor.latest_donation }}</td>
            <td class="text-left py-3 px-4">{{ donor.phone }}</td>
            <td class="text-left py-3 px-4">{{ donor.address.street_address }}<br>{{ donor.address.postal_code }} {{
    donor.address.city }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination-controls @next="nextPage" @prev="prevPage" :url="url" :total="total" :perPage="perPage"
      :page="page"></pagination-controls>
  </div>
</template>
<script>
import axios from 'axios'
import PaginationControls from './PaginationControls'
import _keys from 'lodash/keys'
import _pickBy from 'lodash/pickBy'
import Datepicker from 'vuejs-datepicker'
import { sv } from 'vuejs-datepicker/dist/locale'
import format from 'date-fns/format'
//import { filter } from 'vue/types/umd'
export default {
  components: {
    PaginationControls, Datepicker
  },
  data() {
    return {
      sv: sv,
      total: 0,
      page: 1,
      name: undefined,
      email: undefined,
      ssn: undefined,
      phone: undefined,
      perPage: 20,
      donors: [],
      mail: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>',
      roleSelectOpen: false,
      skogsbutikenRole: false,
      skogsfadderRole: false,
      nyhetsbrevRole: false,
      fromDate: undefined,
      toDate: undefined,
      exportruning: false
    }
  },
  created() {
    this.fetchDonors()
  },
  methods: {
    rolesSelected() {
      const numSelected = [
        this.skogsfadderRole, this.skogsbutikenRole, this.nyhetsbrevRole
      ].reduce((n, x) => n + x, 0)
      return `${numSelected} valda`
    },
    nextPage() {
      this.page += 1
      this.fetchDonors(false)
    },
    prevPage() {
      this.page -= 1
      this.fetchDonors(false)
    },
    async fetchDonors(reset = true) {
      if (reset)
        this.page = 1;
      this.exportruning = true;
      const { data } = await axios.get(`/wp-json/naturarvet/v1/donors?${this.searchParams()}`)
      this.total = parseInt(data.count)
      this.donors = data.donors
      this.exportruning = false;
    },
    searchParams() {
      const params = {
        'per_page': this.perPage,
        'page': this.page,
        'name': this.name,
        'email': this.email ? encodeURIComponent(this.email) : undefined,
        'ssn': this.ssn,
        'phone': this.phone,
        'fromDate': this.fromDate ? format(this.fromDate.getTime(), 'yyyy-MM-dd') : undefined,
        'toDate': this.toDate ? format(this.toDate.getTime(), 'yyyy-MM-dd') : undefined,
        'roles': _keys(_pickBy({
          'forestsponsor': this.skogsfadderRole,
          'forestshop': this.skogsbutikenRole,
          'newsletter': this.nyhetsbrevRole
        })).join(',')
      }
      console.log(params)
      return Object.keys(params)
        .filter(key => params[key])
        .map(key => key + '=' + params[key])
        .join('&');
    },
    show_donor(id) {
      //var filterGet = this.searchParams();
      //filterGet['page'] = 'user';
      window.location = `${this.url}&show=${id}`//&${filterGet}` ;
    },
    exportResult() {
      var dateString = new Date().toISOString().split('T')[0];
      //Propose a file name
      var fileName = `NA_export ${dateString}.csv`
      var exportUrl = `/wp-content/themes/naturarvet-2.0/DonorExport.php?${this.searchParams()}`;
      this.exportruning = true;
      axios({
        url: exportUrl,
        method: 'GET',
        //timeout: 60000,
        responseType: 'blob',
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(response.data);
        var fileLink = document.createElement('a');
        console.log('date: ' + dateString);
        fileLink.href = fileURL;
        fileLink.setAttribute('download', fileName);
        document.body.appendChild(fileLink);

        fileLink.click();
        document.body.removeChild(fileLink);
        window.URL.revokeObjectURL(fileURL);
        this.exportruning = false;
      });
    },
  },
  props: {
    url: String,
  },
  computed: {
    isDisabled() {
      var enable = this.total > 5000;
      return enable;
    },
  },
}
</script>
<style>
@import "https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";
</style>
